<template>
	<div class="row no-padding">
		<div class="col-12 col-med-lg-3 no-padding">
			<p class="type-regular">Good or bad, an experience is always valuable because great art inspires diverse opinions. That's why we call our customer reviews "experiences." We welcome you to share yours.</p>
			<p class="add-initial-bottom-margin__up-to-medium" v-if="isLoggedIn" key="logged-in">
				<button class="btn btn--small {'btn--secondary' : commentEdit.isEditing }" @click="addNewComment">{{ commentButtonText }}</button>
			</p>
			<p class="add-initial-bottom-margin__up-to-medium" v-else key="not-logged-in">
        <button class="btn btn--small" data-micromodal-trigger="login-modal">Share an experience</button>
    	</p>
		</div>
		<div class="col-12 col-med-lg-8 float-r no-padding" role="status">
			<div v-if="!showCommentList">
				There are no comments yet!  Be the first to add yours.
			</div>
			<comments-list
				:productId="productId"
				v-if="showCommentList"
				:showAll="showAll"
				@showAll="showAllComments"
				@cancel-comment="toggleComments"
				:comments="viewableComments" />
			<comment-form
				productId="productId"
				v-if="commentEdit.isEditing"
				@cancel-comment="toggleComments"
				@formSubmit="toggleComments"
				:currentComment="commentEdit.comment" />

		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import CommentsList from './CommentsList.vue';
	import CommentForm from './CommentForm.vue';

	import { FETCH_COMMENTS } from '../vuex/modules/comments/mutations';


	export default {
		name: 'Comments',
		props: ['product-id'],
		components: {
			CommentsList,
			CommentForm,
		},
		data() {
			return {
				// commentButtonText: 'Share an Experience',
				moduleState: {},
				isLoaded: false,
				viewableComments: null,
			}
		},
		mounted() {
			this.$store.commit('setProductId', this.productId);
			this.FETCH_COMMENTS()
				.then(() => {
					this.viewableComments = this.comments.filter(comment => comment.Experience !== null);
				});
    },
		methods: {
			...mapActions({
				FETCH_COMMENTS,
			}),

			/*
			* Click handler for "share an experience" button
			*/
			addNewComment() {
				this.toggleComments();
				this.$store.commit('updateCommentEditState', {});
			},

			/*
			* Toggle visibility if CommentForm component
			*/
			toggleComments() {
				this.$store.commit('toggleComments');
			},

			/*
			* Callback for the editComment event emitted from the individual comment
			*
			* @param comment:
			* @param editing: boolean. Flag for determining whether the request will be POST or PATCH
			*/
			editExistingComment(comment){
				// show the CommentForm component
				this.toggleComments();
			},

			/*
			* Flag to determine whether to truncate the initial view of the comments
			*/
			showAllComments() {
				// this.showAll = true;
				this.$store.commit('showAllComments');
			},
		},
		computed: {
			...mapState({
				isLoggedIn: state => state.AuthStore.isLoggedIn,
				comments: state => state.commentsModule.comments,
				showAll: state => state.commentsModule.showAll,
				commentEdit: state => state.commentsModule.commentEdit,
				isEditing: state => state.commentsModule.commentEdit.isEditing,
			}),

			showCommentList() {
				return !this.commentEdit.isEditing && this.viewableComments !== null;
			},

			commentButtonText() {
				return this.commentEdit.isEditing ? 'Cancel' : 'Share an Experience';
			},
		},
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Comments.vue